import { useEffect, useState } from "react";
import { CloudOff } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { outboxItems, onOutboxChange } from "@/lib/outbox";
import { fmt } from "@/components/recording/useRecorder";

const PendingItem = ({ item }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    const u = URL.createObjectURL(item.blob);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [item.blob]);
  return (
    <li className="bg-amber-50 border border-amber-300 rounded-sm p-3 text-[#1C1917]" data-testid={`pending-recording-${item.key}`}>
      <span className="text-xs text-stone-700">{new Date(item.at).toLocaleString()} · {fmt(item.duration)}</span>
      {url && <audio src={url} controls className="h-9 max-w-full mt-2 block" />}
    </li>
  );
};

// Recordings made without internet; they leave this list once they reach the teacher.
export const PendingRecordings = ({ bookId, page, onSynced }) => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    let first = true;
    const load = () => outboxItems().then((all) => {
      setItems(all.filter((i) => i.type === "recording" && i.book_id === bookId));
      if (!first) onSynced?.();
      first = false;
    }).catch(() => setItems([]));
    load();
    return onOutboxChange(load);
  }, [bookId]); // eslint-disable-line react-hooks/exhaustive-deps

  const here = items.filter((i) => i.page === page);
  if (!here.length) return null;
  return (
    <div data-testid="pending-recordings">
      <p className="text-xs font-bold mb-2 inline-flex items-center gap-1.5 text-amber-900"><CloudOff className="w-4 h-4" /> {t.rec.pending}</p>
      <ul className="space-y-2">{here.map((i) => <PendingItem key={i.key} item={i} />)}</ul>
    </div>
  );
};
